module.exports = __webpack_public_path__ + "img/dingle-donation.8af5503c.jpg";